
























































import Vue from 'vue'
import FeaturedProject from '@/components/FeaturedProject.vue'
import FooterItem from '@/components/FooterItem.vue'
import HeaderPartners from '@/components/HeaderPartners.vue'
import Services from '@/components/Services.vue'
import Experiences from '@/components/Experiences.vue'
import Location from '@/components/Location.vue'
const carousel = require('v-owl-carousel')

export default Vue.extend({
  name: 'home',
  components: {
    FeaturedProject,
    FooterItem,
    HeaderPartners,
    Services,
    Experiences,
    Location,
    carousel
  },
  data: function () {
    return {
      HeaderPartners: {
        img: {
          src: 'assets/img/partners/cluster/cluster-logo.svg',
          alt: 'Asociación sectorial privada sin ánimo de lucro, creada en 2003, cuya finalidad principal es mejorar la competitividad del sector de las Tecnologías de la Información y las Comunicaciones (TIC) en el Principado de Asturias'
        },
        name: 'Cluster TIC',
        description: 'Cluster TIC Asturias es una asociación sectorial privada sin ánimo de lucro, creada en 2003, cuya finalidad principal es mejorar la competitividad del sector de las Tecnologías de la Información y las Comunicaciones (TIC) en el Principado de Asturias y contribuir a la búsqueda de soluciones que incrementen la productividad y la eficiencia empresarial. '
      },
      services: {
        title: 'Áreas de desarrollo estratégico',
        description: 'La actividad del Cluster TIC se dirige a impulsar el crecimiento del sector TIC mediante la cooperación, el intercambio de experiencias, la formación y la especialización profesional para conseguir una mayor participación de las empresas socias en proyectos tecnológicos nacionales e internacionales orientados a la modernización de los sectores tradicionales.',
        services: [
          {
            title: 'Impulsar',
            description: 'el modelo colaborativo Clúster.'
          },
          {
            title: 'Articular',
            description: 'el proceso de toma de decisiones por áreas de interés.'
          },
          {
            title: 'Networking y Participación',
            description: 'Dinamizar la generación de relaciones entre los asociados y la participación de los mismos en las actividades del Cluster TIC.'
          },
          {
            title: 'Recursos Humanos',
            description: 'Identificación de nuevas necesidades formativas y tendencias del mercado laboral.'
          },
          {
            title: 'Internacional',
            description: 'Facilitar el negocio internacional a los socios/as del Clúster.'
          },
          {
            title: 'Innovación',
            description: 'Identificar nuevas líneas de desarrollo de iniciativas de I+D+i y la búsqueda de financiación, socios.'
          },
          {
            title: 'Calidad y procesos',
            description: 'Gestión de calidad y definición de procesos internos del Cluster enfocados a la mejora continua.'
          },
          {
            title: 'Desarrollo de negocio',
            description: 'Área enfocada a la generación de negocio a los socios/as a través del Cluster.'
          },
          {
            title: 'Comunicación',
            description: 'Definición e implementación de la política de comunicación externa e interna del Cluster.'
          }
        ]
      },
      experiences: {
        title: 'Descripción actividad',
        experiences: [
          {
            number: '1',
            description: 'Incorporar metodologías contrastadas y reconocidas internacionalmente, y mejores prácticas empresariales y servicios avanzados en las empresas TIC asturianas.'
          },
          {
            number: '2',
            description: 'Capacitar técnicamente a los/las profesionales del Sector TIC, favoreciendo así una mejora constante en la cualificación de sus recursos humanos.'
          },
          {
            number: '3',
            description: 'Promover la venta exterior de las empresas TIC asturianas.'
          },
          {
            number: '4',
            description: 'Promover y difundir las capacidades del sector TIC asturiano, de forma que éste sea el principal generador de conocimiento tecnológico y que el mercado lo reconozca.'
          },
          {
            number: '5',
            description: 'Fomentar el conocimiento mutuo entre los socios/as y sensibilizar sobre los beneficios de la cooperación.'
          },
          {
            number: '6',
            description: 'Ser mecanismo catalizador de proyectos empresariales en cooperación, articulando medidas específicas. Incrementar la competitividad de las empresas del Sector TIC Asturiano.'
          },
          {
            number: '7',
            description: 'Lograr una mayor participación de las empresas regionales en proyectos de implantación tecnológica.'
          }
        ]
      },
      location: {
        url: 'https://www.google.es/maps/place/Simbiosys/@43.522587,-5.613567,17z/data=!3m1!4b1!4m5!3m4!1s0xd367b19837fcf51:0xb3adf41b77fc354d!8m2!3d43.522587!4d-5.611373',
        img: {
          src: 'assets/img/maps/simbiosys-map.png',
          alt: 'Localización de Simbiosystems S.L.'
        },
        adress: 'Parque Científico Tecnológico de Gijón - C/Profesor Potter, 183. 1ª Planta.33203 Gijón, Asturias - España'
      }
    }
  }
})
